import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-168e721c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "分享给朋友", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "catalog-capsule list-share-reward",
          type: "button",
          "aria-label": "推荐返券",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.shareCatalog && _ctx.shareCatalog(...args)))
        }, "推荐返券"))
      : _createCommentVNode("", true),
    (_ctx.route.path === '/main/bokes')
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "catalog-capsule drawing-pattern-entry",
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.drawingPattern && _ctx.drawingPattern(...args)))
        }, "来图定制"))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: _ctx.shareVisible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.shareVisible) = $event)),
      title: "推荐返券",
      footer: null,
      width: 360
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_a_input, {
          value: _ctx.shareUrl,
          readonly: "",
          "aria-label": "分享链接"
        }, null, 8, ["value"]),
        _createVNode(_component_a_button, {
          type: "primary",
          style: {"margin-top":"16px"},
          onClick: _ctx.send
        }, {
          default: _withCtx(() => [
            _createTextVNode("分享 / 复制链接")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}